import axios from "axios";
import instance from "../../../axios";
import instanceTokenLess from "../../../axiosTokenLess";

// export const API_URL = `${process.env.REACT_APP_EVENTS_API_URL}events`;
export const BASE_URL = `${process.env.REACT_APP_API_URL}`;

// CREATE =>  POST: add a new StaffUser to the server
export function createItem(item) {
  return instance.post(`${BASE_URL}/tournaments/create`, item).then((res) => {
    return res;
  });
}
// READ

export function createSkyItem(item) {
  return instance.post(`${BASE_URL}/tournaments/add`, item).then((res) => {
    return res;
  });
}

export function setCompleteStatusByContestId(item) {
  return instance
    .post(`${BASE_URL}/tournaments/update/${item._id}`, item)
    .then((res) => {
      return res;
    });
}
export function updateMinimumSlot(queryParams) {
  return instance.post(`${BASE_URL}/tournaments/updateMinimumSlot`, queryParams)
    .then(res => {
      return res;
    })
};
export function getList(queryParams) {
  // console.log("listttt=>>", '${BASE_URL}/tournaments/list')
  let headers = {};
  if (queryParams?.search?.company) {
    console.log("queryParams?.search?.company", queryParams?.search?.company);
    headers = {
      "company-code": queryParams?.search?.company || "NW",
    };
  } else {
    headers = {
      "company-code": "NW",
    };
  }
  return instance
    .post(`${BASE_URL}/tournaments/list`, queryParams, { headers })
    .then((res) => {
      return res;
    });
}
export function getListopen(queryParams) {
  // console.log("listttt=>>", '${BASE_URL}/tournaments/list')
  return instance
    .post(`${BASE_URL}/tournaments/listOpenTournament`, queryParams)
    .then((res) => {
      return res;
    });
}

export function getAllGamesList(queryParams) {
  // console.log('queryParams WEWEWE:', queryParams)
  let headers = {};
  if (queryParams?.search?.company) {
    console.log("queryParams?.search?.company", queryParams?.search?.company);
    headers = {
      "company-code": queryParams?.search?.company || "NW",
    };
  } else {
    headers = {
      "company-code": "NW",
    };
  }
  return instance
    .post(
      `${BASE_URL}/gamesDropdownList`,
      {
        company: queryParams?.search?.company,
        pagination: {
          pageNo: parseInt(queryParams?.page || 1),
          recordPerPage: parseInt(queryParams?.limit || 1000),
          sortBy: "name",
          sortDirection: "asc",
        },
        search: queryParams?.search,
      },
      { headers }
    )
    .then((res) => {
      return res;
    });
}

export function getAllTournamentList(queryParams) {
  // console.log('queryParams WEWEWE:', queryParams)
  return instance
    .post(`${BASE_URL}/tournaments/all/list`, {
      search: queryParams?.search,
    })
    .then((res) => {
      return res;
    });
}

export function getTournamentById(id, isExtra) {

  let headers = {};
  const tournamentSelectCompany = localStorage.getItem("tournamentSelectCompany");
  console.log("tournamentSelectCompany",isExtra)
  if (tournamentSelectCompany) {
    //  console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^",tournamentSelectCompany);
    headers = {
      "company-code": tournamentSelectCompany || "GJ",
    };
  } else {
    headers = {
      "company-code": "NW",
    };
  }
  // console.log("^^^^^^^^^^^^^^^^^^^^^",headers)
  return instance.post(`${BASE_URL}/v2/tournaments/get/${id}`, {isExtra: isExtra}, { headers }).then((res) => {
    console.log(res);
    return res;
  });
}
export function getEditTournamentById(id) {

  let headers = {};
  const tournamentSelectCompany = localStorage.getItem("tournamentSelectCompany");
  // console.log("tournamentSelectCompany",isExtra)
  if (tournamentSelectCompany) {
    //  console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^",tournamentSelectCompany);
    headers = {
      "company-code": tournamentSelectCompany || "GJ",
    };
  } else {
    headers = {
      "company-code": "NW",
    };
  }
  // console.log("^^^^^^^^^^^^^^^^^^^^^",headers)
  return instance.post(`${BASE_URL}/tournaments/edit/${id}`, {}, { headers }).then((res) => {
    console.log(res);
    return res;
  });
}



export function getTournamentRoundsById(id) {

  let headers = {};
  const tournamentSelectCompany = localStorage.getItem("tournamentSelectCompany");
  // console.log("tournamentSelectCompany",tournamentSelectCompany)
  if (tournamentSelectCompany) {
    //  console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^",tournamentSelectCompany);
    headers = {
      "company-code": tournamentSelectCompany || "GJ",
    };
  } else {
    headers = {
      "company-code": "NW",
    };
  }
  // console.log("^^^^^^^^^^^^^^^^^^^^^",headers)
  return instance.post(`${BASE_URL}/tournaments/getRounds/${id}`, {}, { headers }).then((res) => {
    console.log(res);
    return res;
  });
}
export function getTournamentMatchesByRounds(id, data) {
  let headers = {};
  const tournamentSelectCompany = localStorage.getItem("tournamentSelectCompany");
  if (tournamentSelectCompany) {
    headers = {
      "company-code": tournamentSelectCompany || "GJ",
    };
  } else {
    headers = {
      "company-code": "NW",
    };
  }
  let data1 = {}
  if (data?.search) {
    data1.search = {
      roundName: data.search?.roundName,
      date: data.search?.date,
      timeSlot: data.search?.timeSlot,
      assignTo: data.search?.assignTo,
      status: data.search?.status,
      createdAt: data.search?.createdAt,
    }

  } else {
    data1.search = {
      roundName: "",
      date: Date.now(),
      timeSlot: "all",
      assignTo: "all",
      status: "all",
      createdAt:null,
    }
  }
  return instance.post(`${BASE_URL}/tournaments/getMatches/${id}`, data1, { headers }).then((res) => {
    console.log(res);
    return res;
  });
}

export function getTournamentRulesById(id) {
  return instance.post(`${BASE_URL}/tournaments/rules/${id}`).then((res) => {
    console.log(res);
    return res;
  });
}
export function exportJoinedUserByContestIdApi(id) {
  return instance.post(`${BASE_URL}/tournaments/exportJoinedContestUserByContestId/${id}`,{export:true})
    .then(res => {
      return res;
    })
};
export function getTournamentPointPoolById(id) {
  return instance
    .post(`${BASE_URL}/tournaments/pointPool/${id}`)
    .then((res) => {
      console.log(res);
      return res;
    });
}

export function getTournamentPrizePoolById(id) {
  return instance
    .post(`${BASE_URL}/tournaments/prizePool/${id}`)
    .then((res) => {
      console.log(res);
      return res;
    });
}

export function getItemById(id) {
  return instance.post(`${BASE_URL}/tournaments/view/${id}`).then((res) => {
    console.log(res);
    return res;
  });
}

export function getContestUsersList(queryParams) {
  return instance
    .post(`${BASE_URL}/tournaments/tournamentJoinedUsers/${queryParams.id}`, {
      pagination: {
        pageNo: parseInt(queryParams.page) ? parseInt(queryParams.page) : 1,
        recordPerPage: parseInt(queryParams.limit)
          ? parseInt(queryParams.limit)
          : 10,
        sortBy: queryParams.sortBy,
        sortDirection: queryParams.sort,
      },
    })
    .then((res) => {
      return res;
    });
}

export function acceptedTournamentUserList(queryParams) {
  return instance
    .post(`${BASE_URL}/tournaments/acceptedUser/${queryParams?.tournamentId}`, {
      matchId: queryParams?.matchId,
      phoneNo: queryParams?.phoneNo,
      pagination: {
        pageNo: parseInt(queryParams.page) ? parseInt(queryParams.page) : 1,
        recordPerPage: parseInt(queryParams.limit)
          ? parseInt(queryParams.limit)
          : 10,
        sortBy: queryParams.sortBy,
        sortDirection: queryParams.sort,
      },
    })
    .then((res) => {
      return res;
    });
}

export function contestAllocatedUserList(queryParams) {
  return instance
    .post(`${BASE_URL}/tournaments/allocatedTeamUserList`, {
      matchId: queryParams,
      pagination: {
        pageNo: 1,
        recordPerPage: 100000,
        sortBy: "createdAt",
        sortDirection: "desc",
      },
    })
    .then((res) => {
      return res;
    });
}

export function contestViewbyId(queryParams) {
  return instance
    .post(`${BASE_URL}/tournament/contest/${queryParams}`)
    .then((res) => {
      return res;
    });
}

export function acceptTournamentUser(queryParams) {
  return instance
    .post(`${BASE_URL}/tournaments/acceptUser/${queryParams}`)
    .then((res) => {
      return res;
    });
}

export function acceptUserForContest(queryParams) {
  return instance
    .post(`${BASE_URL}/tournaments/teamAllocation`, queryParams)
    .then((res) => {
      return res;
    });
}

export function rejectTournamentUser(queryParams) {
  return instance
    .post(`${BASE_URL}/tournaments/rejectUser/${queryParams}`)
    .then((res) => {
      return res;
    });
}

export function deleteStatusTournamentUser(queryParams) {
  return instance
    .post(`${BASE_URL}/tournaments/statusUndo/${queryParams}`)
    .then((res) => {
      return res;
    });
}

export function getItemPointSummaryById(id) {
  return instance
    .post(`${BASE_URL}/tournaments/pointSummery/${id}`)
    .then((res) => {
      return res;
    });
}

export function getItemGamerjiPointSummaryById(id) {
  return instance
    .post(`${BASE_URL}/gamerjiTournaments/pointSummery/${id}`)
    .then((res) => {
      return res;
    });
}

export function getItemGamerjiPointSummaryByIdexport(id, options = {}) {
  const { exportOption } = options;

  const params = {
    // other parameters...
    export: exportOption || true, // Set export to the provided value or false if not provided
  };

  return instance
    .post(`${BASE_URL}/gamerjiTournaments/pointSummery/${id}`, params)
    .then((res) => {
      return res;
    });
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findItem(queryParams) {
  return axios.post(`${BASE_URL}/find`, { queryParams });
}

// UPDATE => PUT: update the StaffUser on the server
export function updateItem(item) {
  return instance
    .post(`${BASE_URL}/tournaments/update/${item._id}`, item)
    .then((res) => {
      return res;
    });
}
export function updateSkyItem(item) {
  return instance
    .post(`${BASE_URL}/tournaments/sky/update/${item._id}`, item)
    .then((res) => {
      return res;
    });
}

// UPDATE => PUT: update the StaffUser on the server
export function updateEventWinnings(item, id) {
  return axios.post(`${BASE_URL}/update-winnings/${id}`, item);
}

// UPDATE Status
export function updateItemsStatus(ids, status) {
  return axios.post(`${BASE_URL}/updateStatusForitems`, {
    ids,
    status,
  });
}

// DELETE => delete the StaffUser from the server
export function deleteItem(id) {
  return axios.post(`${BASE_URL}/delete/${id}`);
}

// DELETE items by ids
export function deleteItems(ids) {
  return axios.post(`${BASE_URL}/deleteitems`, { ids });
}
export function fetchCountriesList(queryParams) {
  console.log("LLLLLLLLLLL:", queryParams);
  return instance.post(`${BASE_URL}/country/list`, queryParams).then((res) => {
    return res;
  });
}

export function updateGamerjiEventWinnings(item, id) {
  return instance
    .post(`${BASE_URL}/gamerjiTournaments/winning/${id}`, item)
    .then((res) => {
      return res;
    });
}


export function updateGamerjiEventWinningsreward(item, id) {
  return instance
    .post(`${BASE_URL}/gamerjiTournaments/reward-winning/${id}`, item)
    .then((res) => {
      return res;
    });
}
// prizePoolType

export function fetchCompanyDropdownList(queryParams) {
  console.log("dropdown:", queryParams);
  return instance
    .post(`${BASE_URL}/v3/dropdown/company/short`, queryParams)
    .then((res) => {
      return res;
    });
}

export function fetchCountriesDropdownList(queryParams) {
  console.log("dropdown:", queryParams);
  return instance
    .post(`${BASE_URL}/v3/dropdown/country/lite`, queryParams)
    .then((res) => {
      return res;
    });
}

export function fetchCurrencyList(queryParams) {
  return instance.post(`${BASE_URL}/currency/list`, queryParams).then((res) => {
    return res;
  });
}

export function fetchCurrencyDropdownList(queryParams) {
  return instance
    .post(`${BASE_URL}/currency/Dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}

export function getCompanyById(id) {
  //return axios.post(`${LOCAL_URL}/appsflyer-tokens/get/${id}`);
  return instance.post(`${BASE_URL}/v3/dropdown/currency/lite/${id}/dropdown`).then((res) => {
    return res;
  });
}

export function uploadImage(file) {
  let formData = new FormData();
  formData.append("file", file);
  // let url ='http://localhost:9155/api/common/upload-image'
  let url = BASE_URL + "/image/upload";

  return instance.post(`${url}`, formData);
}

export function getGameList(queryParams) {
  return instanceTokenLess
    .post(`${BASE_URL}/game/list`, queryParams)
    .then((res) => {
      return res;
    });
}

export function gameTypeList(queryParams) {
  return instanceTokenLess
    .post(`${BASE_URL}/gameType/list`, queryParams)
    .then((res) => {
      return res;
    });
}

// CREATE =>  POST: add a new StaffUser to the server
export function createTournamentsRound(item) {
  return instance
    .post(`${BASE_URL}/tournaments/rounds/add`, item)
    .then((res) => {
      return res;
    });
}

export function setContestIdPassword(item) {
  return instance
    .post(`${BASE_URL}/tournament/contest/roomIdPasswordSave/${item._id}`, item)
    .then((res) => {
      return res;
    });
}

export function resetRoomIdPassword(item) {
  return instance
    .post(
      `${BASE_URL}/tournament/contest/roomIdPasswordReset/${item._id}`,
      item
    )
    .then((res) => {
      return res;
    });
}

export function rescheduleContest(item) {
  return instance
    .post(`${BASE_URL}/tournament/contest/reschedule/${item._id}`, item)
    .then((res) => {
      return res;
    });
}

export function saveScreenShotImage(queryParams) {
  // console.log(queryParams.screenshotImages)
  let ss = {};
  ss.screenshotImages = queryParams.screenshotImages;
  // let ss = queryParams.screenshotImages
  return instance
    .post(
      `${BASE_URL}/tournament/contest/screenShotImageSave/${queryParams.id}`,
      ss
    )
    .then((res) => {
      return res;
    });
}

export function resetScreenshotImage(item) {
  return instance
    .post(
      `${BASE_URL}/tournament/contest/screenShotImageReset/${item._id}`,
      item
    )
    .then((res) => {
      return res;
    });
}

export function contestCancel(item) {
  return instance
    .post(`${BASE_URL}/tournament/contest/cancel/${item._id}`, item)
    .then((res) => {
      return res;
    });
}

export function updateTotalJoinedPlayers(queryParams) {
  //let localUrl ='http://localhost:9155/api'
  // console.log(queryParams.screenshotImages)
  let data = {};
  data.totalJoinedPlayers = queryParams.totalJoinedPlayers;
  // let ss = queryParams.screenshotImages
  return instance
    .post(
      `${BASE_URL}/tournament/contest/totalJoinedUserSave/${queryParams.id}`,
      data
    )
    .then((res) => {
      return res;
    });
}
// upload brackets image
export function uploadBracketsImage(file) {
  let formData = new FormData();
  formData.append("file", file);
  let url = BASE_URL + "/image/upload";

  return instance.post(`${url}`, formData);
}

// CREATE =>  POST: add a new StaffUser to the server
export function saveBracketsImage(body) {
  return instance
    .post(
      `${BASE_URL}/tournaments/bracketsImageUpload/${body.tournamentId}`,
      body
    )
    .then((res) => {
      return res;
    });
}
// delete match round
export function deleteMatchRound(roundID) {
  return instance
    .delete(
      `${BASE_URL}/tournaments/rounds/delete/${roundID._id}/${roundID.tournamentId}`
    )
    .then((res) => {
      return res;
    });
}
// save contest result
export function saveContestResult(body) {
  return instance
    .post(
      `${BASE_URL}/tournaments/contest/winningUpload/${body.tournamentId}`,
      body
    )
    .then((res) => {
      return res;
    });
}
// get rank summary data
export function getRankSummary(tournamentId) {
  return instance
    .post(`${BASE_URL}/tournaments/rankSummery/${tournamentId}`)
    .then((res) => {
      return res;
    });
}

export function getGamerjiRankSummary(tournamentId) {
  return instance
    .post(`${BASE_URL}/gamerjiTournaments/rankSummery/${tournamentId}`)
    .then((res) => {
      return res;
    });
}
export function getGamerjiRankSummaryByIdexport(tournamentId, options = {}) {
  const { exportOption } = options;

  const params = {
    // other parameters...
    export: exportOption || true, // Set export to the provided value or false if not provided
  };

  return instance
    .post(`${BASE_URL}/gamerjiTournaments/rankSummery/${tournamentId}`, params)
    .then((res) => {
      return res;
    });
}
// update Winning summary & rank base
export function updateWinning(payload) {
  let param = {
    contestPlayer: payload.contestPlayer,
  };
  return instance
    .post(
      `${BASE_URL}/tournaments/updateWinning/${payload.tournamentId}`,
      param
    )
    .then((res) => {
      return res;
    });
}

export function getTounamentReport(queryParams) {
  // return axios.post(`${API_URL}reports/eventReport`, queryParams);
  return instance
    .post(`${BASE_URL}/reports/gamerji/eventReport`, queryParams)
    .then((res) => {
      return res;
    });
}

export function getTournamentReportExportList(queryParams) {
  return instance
    .post(`${BASE_URL}/reports/gamerji/eventReportExport`, queryParams)
    .then((res) => {
      return res;
    });

}
export function getTournamentRoundCount(id) {
  return instance
    .get(`${BASE_URL}/v2/tournaments/gettotalround/${id}`)
    .then((res) => {
      return res;
    });
}
export function getTournamentContestCount(id) {
  return instance
    .get(`${BASE_URL}/v2/tournaments/gettotalcontest/${id}`)
    .then((res) => {
      return res;
    });
}
export function getTournamentFullContestCount(id) {
  return instance
    .get(`${BASE_URL}/v2/tournaments/gettotalfullcontest/${id}`)
    .then((res) => {
      return res;
    });
}
export function getTournamentCancellationReason(id) {
  return instance
    .get(`${BASE_URL}/v2/tournaments/getcancellationreason/${id}`)
    .then((res) => {
      return res;
    });
}
export function getAllStaffUsers(id) {
  // return axios.post(`${STAFFUSER_URL}/list`, queryParams);
  return instance.post(`${BASE_URL}/adminuser/assign/list`, { "pagination": { "recordPerPage": 5000 }, event: id, "fromDate": null, "toDate": null })
    .then(res => {
      return res;
    })
}